import React, { useState } from 'react';
const faqs = [{
  q: '¿Quién escribió esta guía?',
  a: 'Roderic Guillen — a partir de años de investigación personal motivada por una experiencia crítica de salud, basada en estudios publicados en Nature, Diabetes Care y Clinical Nutrition.'
}, {
  q: '¿Es consejo médico?',
  a: 'No. Es contenido educativo basado en investigación científica. Consulta siempre a un profesional de salud.'
}, {
  q: '¿Necesito conocimientos previos?',
  a: 'No. Cada concepto se explica desde cero con analogías simples.'
}, {
  q: '¿Cuánto tiempo tarda en leer?',
  a: 'Una hora. Puede leerse completo o por partes según tu ritmo.'
}, {
  q: '¿Cómo recibo el archivo?',
  a: 'Descarga inmediata en PDF después del pago.'
}, {
  q: '¿Puedo compartirlo con mi familia?',
  a: 'Sí. Está diseñado para que cualquier persona lo entienda, sin importar su edad ni nivel de conocimiento.'
}, {
  q: '¿Funciona si tengo diabetes tipo 2 u otra condición metabólica?',
  a: 'Es material educativo basado en los AGEs. Si tienes una condición diagnosticada, te invitamos a leerlo siempre como complemento informativo y siempre en diálogo con tu médico tratante.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [allOpen, setAllOpen] = useState(false);
  const toggleAll = () => {
    setAllOpen(!allOpen);
    setOpenIndex(null);
  };
  const toggleItem = (index: number) => {
    if (allOpen) setAllOpen(false);
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 md:py-28 px-4 bg-dark-primary" data-id="element-283">
      <div className="max-w-content mx-auto" data-id="element-284">
        <div className="text-center mb-12" data-id="element-285">
          <button onClick={toggleAll} className="font-serif text-3xl md:text-4xl text-cream hover:text-gold transition-colors cursor-pointer" data-id="element-286">
            Preguntas Frecuentes
          </button>
        </div>

        <div className="space-y-4" data-id="element-287">
          {faqs.map((faq, idx) => {
          const isOpen = allOpen || openIndex === idx;
          return <div key={idx} className="bg-dark-card border border-border-subtle rounded-lg overflow-hidden" data-id="element-288">
                <button onClick={() => toggleItem(idx)} className="w-full flex items-center justify-between p-6 text-left hover:bg-dark-secondary transition-colors" data-id="element-289">
                  <span className="font-sans font-medium text-cream text-[16px] pr-8" data-id="element-290">
                    {faq.q}
                  </span>
                  <span className={`text-gold transform transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-90' : ''}`} data-id="element-291">
                    ▶
                  </span>
                </button>

                {isOpen && <div className="p-6 pt-0 border-t border-border-subtle/50 mt-2 animate-in fade-in duration-300" data-id="element-292">
                    <p className="font-sans text-gray-warm text-[15px] leading-relaxed" data-id="element-293">
                      {faq.a}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}